import type { WorkflowCardData } from '@/data/modalityWorkflows'

interface WorkflowCardProps {
  workflow: WorkflowCardData
}

export default function WorkflowCard({ workflow }: WorkflowCardProps) {
  return (
    <a 
      href={workflow.href} 
      className="bg-white/75 hover:bg-white/100 border border-gray-200 rounded-lg p-4 hover:border-purple-300 hover:shadow-sm transition-all duration-200 group"
    >
      <div className="flex items-center justify-between">
        <div>
          <h5 className="font-medium text-gray-900 group-hover:text-purple-700">
            {workflow.title}
          </h5>
          <p className="text-sm text-gray-600">
            {workflow.description}
          </p>
        </div>
        <svg 
          className="h-5 w-5 text-gray-400 group-hover:text-purple-500" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M9 5l7 7-7 7" 
          />
        </svg>
      </div>
    </a>
  )
}